/*
 * Bölgesel varyant hafızası.
 *
 * `snippets/region-plug-type.liquid` ziyaretçinin ÜLKESİNE bakarak bir priz
 * tipi seçiyor. Bu dosya o seçimin yalnızca VARSAYILAN kalmasını sağlar:
 * müşteri bir kez kendi tercihini yaptığında tercih saklanır ve sonraki
 * sayfalarda geri yüklenir — bölge varsayılanı bir daha üstüne yazmaz.
 *
 * Neden istemci tarafında: Liquid `localStorage` okuyamaz ve tercih sunucuya
 * gönderilmiyor. Sunucu bölgeye uyan varyantı basar, biz yükleme bittikten
 * hemen sonra saklanan tercihe çeviririz. Dört priz varyantının fiyatı ve
 * görseli aynı olduğu için bu düzeltme gözle görülür bir zıplama yapmıyor;
 * fiyatları ayrışan bir seçenek için aynı yöntem uygun olmaz.
 *
 * Zamanlama: hem `collection-storefront.js` hem `main-product.js` defer ile
 * yükleniyor ve çalıştıkları anda dinleyicilerini bağlıyor. Bu dosya belgede
 * onlardan ÖNCE geldiği için işini `setTimeout(0)` ile erteler; yoksa
 * gönderdiğimiz `change` olayını dinleyen kimse olmazdı.
 */
(() => {
  if (window.__vmRegionVariantMemory) return;
  window.__vmRegionVariantMemory = true;

  const KEY = 'vanemar:variant-pref';

  /* `snippets/region-plug-type.liquid`in üretebildiği değerlerin aynısı.
     Buraya bir değer eklemeden önce snippet'e de ekle. Listede olmayan hiçbir
     seçim (renk, beden, adet) hatırlanmaz — hafıza yalnızca bölgeye bağlı
     seçenek içindir. */
  const TOKENS = ['US', 'EU', 'AU', 'FR'];

  /* Kendi geri yüklememiz yeniden kayıt tetiklemesin. */
  let restoring = false;

  const readPref = () => {
    try {
      const value = localStorage.getItem(KEY);
      return TOKENS.indexOf(value) > -1 ? value : null;
    } catch (e) {
      return null;
    }
  };

  const writePref = (value) => {
    const token = (value || '').trim();
    if (TOKENS.indexOf(token) < 0) return;
    try {
      localStorage.setItem(KEY, token);
    } catch (e) {
      /* Gizli sekmede ya da depolama kapalıyken sessizce vazgeç: hafıza bir
         kolaylık, çalışmadığında bölge varsayılanı geçerli kalır. */
    }
  };

  const tokenIn = (options) => {
    if (!options) return null;
    for (let i = 0; i < options.length; i += 1) {
      const value = String(options[i]).trim();
      if (TOKENS.indexOf(value) > -1) return value;
    }
    return null;
  };

  /* PDP açılır listesi yalnızca varyant id'si taşır; seçenek değeri bölümün
     kendi JSON yükünde. */
  const pdpTokenForId = (id) => {
    const nodes = document.querySelectorAll('script[data-pdp-variants]');
    for (let i = 0; i < nodes.length; i += 1) {
      let payload;
      try {
        payload = JSON.parse(nodes[i].textContent);
      } catch (e) {
        continue;
      }
      const variants = (payload && payload.variants) || [];
      for (let j = 0; j < variants.length; j += 1) {
        if (String(variants[j].id) === String(id)) return tokenIn(variants[j].options);
      }
    }
    return null;
  };

  /* ---------- Kayıt: müşteri ne seçtiyse o ---------- */
  document.addEventListener('change', (event) => {
    if (restoring) return;
    const el = event.target;
    if (!el || !el.matches) return;

    if (el.matches('[data-cs-variant-select]')) {
      const option = el.selectedOptions[0];
      if (option) writePref(option.getAttribute('data-variant-title'));
    } else if (el.matches('[data-pdp-option]')) {
      writePref(el.value);
    } else if (el.matches('[data-pdp-variant-select]')) {
      writePref(pdpTokenForId(el.value));
    }
  });

  /* ---------- Geri yükleme ---------- */
  const select = (el, apply) => {
    restoring = true;
    apply();
    el.dispatchEvent(new Event('change', { bubbles: true }));
    restoring = false;
  };

  const restoreCards = (pref, scope) => {
    scope.querySelectorAll('[data-cs-variant-select]').forEach((el) => {
      const match = Array.prototype.find.call(
        el.options,
        (option) =>
          (option.getAttribute('data-variant-title') || '').trim() === pref &&
          option.getAttribute('data-available') !== 'false'
      );
      if (!match || match.selected) return;
      select(el, () => {
        el.value = match.value;
      });
    });
  };

  const restoreProduct = (pref, scope) => {
    /* Adreste `?variant=` varsa sunucu o varyantı bilerek bastı — müşteri
       belirli bir varyantın linkine tıklamış demektir, tercih onu ezmez.
       Ölçütü Liquid koyar (`data-pdp-variant-implicit`); bölge hafızası da
       yalnız bölüm ayarı açıkken (`data-pdp-region-memory`) çalışır. */
    scope.querySelectorAll('[data-pdp-root]').forEach((root) => {
      if (!root.hasAttribute('data-pdp-variant-implicit')) return;
      if (!root.hasAttribute('data-pdp-region-memory')) return;

      const dropdown = root.querySelector('[data-pdp-variant-select]');
      if (dropdown) {
        const match = Array.prototype.find.call(
          dropdown.options,
          (option) => !option.disabled && pdpTokenForId(option.value) === pref
        );
        if (match && !match.selected) {
          select(dropdown, () => {
            dropdown.value = match.value;
          });
        }
        return;
      }

      const input = Array.prototype.find.call(
        root.querySelectorAll('[data-pdp-option]'),
        (el) => (el.value || '').trim() === pref && !el.disabled
      );
      if (input && !input.checked) {
        select(input, () => {
          input.checked = true;
        });
      }
    });
  };

  const restore = (scope) => {
    const pref = readPref();
    if (!pref) return;
    restoreCards(pref, scope);
    restoreProduct(pref, scope);
  };

  setTimeout(() => restore(document), 0);
  document.addEventListener('shopify:section:load', (event) => {
    setTimeout(() => restore(event.target), 0);
  });
})();
